import { render, staticRenderFns } from "./ProfilTab.vue?vue&type=template&id=13ef17a6"
import script from "./ProfilTab.vue?vue&type=script&lang=js"
export * from "./ProfilTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports